export default __webpack_public_path__ + "fd3fc0358d08abb892ccfd9c57b21a81.svg";